import {
    Box,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow,
    Text,
    Flex,
    Image
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import Verified from './assets/verified.svg'

interface IVerifiedTick {
    authorRole?: string;
}

export default function VerifiedTick({
    authorRole = '',
}: IVerifiedTick) {
    const { t } = useTranslation();
    if (authorRole == '' || authorRole == null) return <Box w='14px' h='14px' />

    return (
        <Box position='relative' top={'1px'} w='14px' h='14px' mr='14px'>
            <Popover trigger='hover'>
                <PopoverTrigger>
                    <Image src={Verified} w='14px' h='14px' minW='14px' />
                </PopoverTrigger>
                <PopoverContent bg='#EDF2F7' color='black' w={'180px'} p='8px'>
                    <PopoverArrow />
                    <PopoverBody>
                        <Flex w={'100%'} justifyContent={'center'} alignItems='center' direction={'column'}>
                            <Image src={Verified} w='20px' h='20px' minW='20px' />
                            {authorRole == 'admin' ? (
                                <>
                                    <Text fontSize='12px' fontWeight={'600'}>
                                        {t("VerifiedTick.officialMember")}
                                    </Text>
                                    <Text fontSize='10px' fontWeight={'400'}>
                                        {t("VerifiedTick.officialMemberLead")}
                                    </Text>
                                </>

                            ) : (
                                <>
                                    <Text fontSize='12px' fontWeight={'600'} textAlign='center'>
                                        {t("VerifiedTick.olaCreator")}
                                    </Text>
                                    <Text fontSize='10px' fontWeight={'400'} textAlign='center'>
                                        {t("VerifiedTick.olaCreatorLead")}
                                    </Text>
                                </>
                            )}
                        </Flex>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </Box>
    )
}
